export const BASE_URL = process.env.BASE_URL;
export const SERVER_URL = `${BASE_URL}/api`;
export const CLIENT_URL = '/api';
